import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH4Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FeatureCard2",
  props: {
    icon: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          styles: {
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 100,
                border_left_bottom_radius: 100,
                border_right_top_radius: 100,
                border_right_bottom_radius: 100,
              },
            }),
            sizing: getSizingOptions({
              defaultValue: {
                width: "54px",
                height: "54px",
                minWidth: "54px",
                minHeight: "54px",
                maxWidth: "54px",
                maxHeight: "54px",
              },
            }),
          },
        }),
      ],
    },
    titleContent: {
      prop: "children",
      type: "children",
      value: [
        createH4Block({
          text: "Clarity & Vision",
        }),
      ],
    },
    image: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "32px",
                minWidth: "100%",
                minHeight: "32px",
                maxWidth: "100%",
                maxHeight: "32px",
              },
            }),
          },
        }),
      ],
    },
    description: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Discover your authentic values, strengths, and purpose to create a compelling vision for your future.",
        }),
      ],
    },
  },
};
